import React from 'react';
import BlogTile from './BlogTile';
import { BLOG_POSTS } from './Blog';

function ServiceBlogSection({ blogSlugs = [] }) {
  const posts = blogSlugs.map(slug => BLOG_POSTS.find(post => post.slug === slug)).filter(Boolean);
  let gridClass = 'max-w-3xl mx-auto';
  if (posts.length === 2) gridClass = 'max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8';
  if (posts.length >= 3) gridClass = 'max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8';

  return (
    <section className="mt-16 mb-8">
      <h2 className="text-2xl font-semibold text-[#b87c4c] mb-6 text-center">Tips & Resources</h2>
      <div className={gridClass}>
        {posts.map(post => <BlogTile key={post.slug} post={post} />)}
      </div>
      <div className="flex justify-center mt-6">
        <a 
          href="/blog" 
          className="inline-block px-6 py-2 bg-white border-2 border-[#8B4513] text-[#8B4513] font-medium rounded-lg shadow-sm hover:bg-[#f8f7f3] hover:border-[#6B3410] hover:text-[#6B3410] transition-colors duration-200"
        >
          See all articles
        </a>
      </div>
    </section>
  );
}

export default ServiceBlogSection; 